/** Shared quick-reply category labels (Tools + Inbox snippet picker) */

export const SNIPPET_PRESET_KEYS = ['general', 'greeting', 'inquiry', 'followup', 'closing'];

export const SNIPPET_CATEGORY_I18N = {
  general: { ar: 'عام', en: 'General' },
  greeting: { ar: 'تحية', en: 'Greeting' },
  inquiry: { ar: 'استفسار', en: 'Inquiry' },
  followup: { ar: 'متابعة', en: 'Follow-up' },
  closing: { ar: 'إغلاق', en: 'Closing' },
};

export function formatSnippetCategoryLabel(key, language) {
  const k = String(key || 'general').trim().toLowerCase();
  const row = SNIPPET_CATEGORY_I18N[k];
  if (row) return language === 'ar' ? row.ar : row.en;
  const display = String(key || '').trim();
  if (!display) return language === 'ar' ? SNIPPET_CATEGORY_I18N.general.ar : SNIPPET_CATEGORY_I18N.general.en;
  return display.replace(/_/g, ' ');
}

export function isPresetSnippetCategory(key) {
  return SNIPPET_PRESET_KEYS.includes(String(key || '').trim().toLowerCase());
}

export function normalizeSnippetCategoryForSave(raw) {
  const t = String(raw ?? '').trim().slice(0, 64);
  return t || 'general';
}
